import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import PreviewAttachments from 'modules/processes/components/ItemWizard/components/Preview/Attachments'
import PreviewDescription from 'modules/processes/components/ItemWizard/components/Preview/Description'
import DocumentToComplete from 'modules/processes/components/ItemWizard/components/Preview/DocumentToComplete'
import PreviewTitle from 'modules/processes/components/ItemWizard/components/Preview/Title'

const Preview = () => {
  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />
      <DocumentToComplete />
    </Box>
  )
}

export default Preview
